import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { datePickerInjectionKey as Y } from "../interface.js";
import A from "../../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-keyboard.js";
import { inject as B, computed as E, nextTick as D } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as m } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const K = "HH:mm:ss", U = {
  active: Boolean,
  dateFormat: String,
  calendarDayFormat: String,
  calendarHeaderYearFormat: String,
  calendarHeaderMonthFormat: String,
  calendarHeaderMonthYearSeparator: {
    type: String,
    required: !0
  },
  calendarHeaderMonthBeforeYear: {
    type: Boolean,
    default: void 0
  },
  timePickerFormat: {
    type: String,
    value: K
  },
  value: {
    type: [Array, Number],
    default: null
  },
  shortcuts: Object,
  defaultTime: [Number, String, Array],
  inputReadonly: Boolean,
  onClear: Function,
  onConfirm: Function,
  onClose: Function,
  onTabOut: Function,
  onKeydown: Function,
  actions: Array,
  onUpdateValue: {
    type: Function,
    required: !0
  },
  themeClass: String,
  onRender: Function,
  panel: Boolean,
  onNextMonth: Function,
  onPrevMonth: Function,
  onNextYear: Function,
  onPrevYear: Function
};
function z(t) {
  const {
    dateLocaleRef: h,
    timePickerSizeRef: F,
    timePickerPropsRef: P,
    localeRef: v,
    mergedClsPrefixRef: g,
    mergedThemeRef: y
  } = B(Y), C = E(() => ({
    locale: h.value.locale
  })), a = m(null), u = A();
  function S() {
    const {
      onClear: e
    } = t;
    e && e();
  }
  function b() {
    const {
      onConfirm: e,
      value: n
    } = t;
    e && e(n);
  }
  function l(e, n) {
    const {
      onUpdateValue: o
    } = t;
    o(e, n);
  }
  function d(e = !1) {
    const {
      onClose: n
    } = t;
    n && n(e);
  }
  function r() {
    const {
      onTabOut: e
    } = t;
    e && e();
  }
  function p() {
    l(null, !0), d(!0), S();
  }
  function T() {
    r();
  }
  function k() {
    (t.active || t.panel) && D(() => {
      const {
        value: e
      } = a;
      if (!e)
        return;
      const n = e.querySelectorAll("[data-n-date]");
      n.forEach((o) => {
        o.classList.add("transition-disabled");
      }), e.offsetWidth, n.forEach((o) => {
        o.classList.remove("transition-disabled");
      });
    });
  }
  function R(e) {
    e.key === "Tab" && e.target === a.value && u.shift && (e.preventDefault(), r());
  }
  function M(e) {
    const {
      value: n
    } = a;
    u.tab && e.target === n && (n != null && n.contains(e.relatedTarget)) && r();
  }
  let f = null, i = !1;
  function O() {
    f = t.value, i = !0;
  }
  function V() {
    i = !1;
  }
  function s() {
    i && (l(f, !1), i = !1);
  }
  function x(e) {
    return typeof e == "function" ? e() : e;
  }
  const c = m(!1);
  function H() {
    c.value = !c.value;
  }
  return {
    mergedTheme: y,
    mergedClsPrefix: g,
    dateFnsOptions: C,
    timePickerSize: F,
    timePickerProps: P,
    selfRef: a,
    locale: v,
    doConfirm: b,
    doClose: d,
    doUpdateValue: l,
    doTabOut: r,
    handleClearClick: p,
    handleFocusDetectorFocus: T,
    disableTransitionOneTick: k,
    handlePanelKeyDown: R,
    handlePanelFocus: M,
    cachePendingValue: O,
    clearPendingValue: V,
    restorePendingValue: s,
    getShortcutValue: x,
    handleShortcutMouseleave: s,
    showMonthYearPanel: c,
    handleOpenQuickSelectMonthPanel: H
  };
}
export {
  z as usePanelCommon,
  U as usePanelCommonProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/use-panel-common.js
// module id = 947
// module chunks = 67